import {
  TRANSACTION_LIST_PAGE_LOADED,
  TRANSACTION_LIST_NEXT_PAGE_LOADED,
  TRANSACTION_LIST_PAGE_UNLOADED,
  ETH_COMMIT_TRANSACTION_LIST_PAGE_LOADED,
  ETH_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED,
  BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED,
  BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED,
  TRANSACTION_LIST_SEARCH_LOADED,
  UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM,
  TRANSACTION_LIST_EXPORT
} from '../constants/actionTypes'
import { PAGESIZE } from '../constants/config'
export default (state = {}, action) => {
  switch (action.type) {
    case TRANSACTION_LIST_PAGE_LOADED:
    case TRANSACTION_LIST_SEARCH_LOADED:
    case TRANSACTION_LIST_NEXT_PAGE_LOADED:
      return {
        ...state,
        transactions: action.payload.transactions,
        totalCount: action.payload.totalCount,
        currentPage: action.currentPage,
        totalPage: Math.ceil(action.payload.totalCount / PAGESIZE),
        searchTerm: action.searchTerm,
        date_from: action.date_from,
        date_to: action.date_to,
        csvData: null
      }
    case ETH_COMMIT_TRANSACTION_LIST_PAGE_LOADED:
    case BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED:
      return {
        ...state,
        user: action.payload.user,
        ex_transactions: action.payload.ex_transactions,
        spnc_transactions: action.payload.spnc_transactions,
        ex_account: action.payload.ex_account,
        spnc_account: action.payload.spnc_account,
        spnc_local_transactions: action.payload.spnc_local_transactions,
        csvData: null
      }
    case TRANSACTION_LIST_PAGE_UNLOADED:
    case ETH_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED:
    case BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED:
      return {}
    case UPDATE_FIELD_TRANSACTION_LIST_SEARCHTERM:
      return {
        ...state,
        [action.key]: action.value,
        csvData: null
      }
    case TRANSACTION_LIST_EXPORT:
      return {
        ...state,
        csvData: action.payload
      }
    default:
      return state
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transaction.js